
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34 34"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.977 29.019a3.018 3.018 0 01-2.13-.884l-8.038-8.038a3.015 3.015 0 014.26-4.26l5.908 5.908L27.931 5.79a3.014 3.014 0 014.26 4.26L14.106 28.135a3.014 3.014 0 01-2.129.884z"}})])
          )
        }
      }
    